import { IEntityCategoryPayload, IUpdateRulePayloadType } from '../types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const fetchCriteria = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}v1/eligibility_configuration/criteria`
  )
}

export const fetchRulesOffCriteria = async (
  criteriaId: string,
  programId: string,
  productId?: string
) => {
  if (productId) {
    return await axiosInstance.get(
      `${API_END_POINT.CORE}v1/eligibility_configuration/rules?programId=${programId}&productId=${productId}&criteria=${criteriaId}`
    )
  } else {
    return await axiosInstance.get(
      `${API_END_POINT.CORE}v1/eligibility_configuration/rules?programId=${programId}&criteria=${criteriaId}`
    )
  }
}

export const fetchRule = async (
  rule_id: string,
  program_id: string,
  rule_name: string,
  product_id?: string
) => {
  if (product_id) {
    return await axiosInstance.get(
      `${
        API_END_POINT.CORE
      }v1/eligibility_configuration/${rule_name?.toLowerCase()}?programId=${program_id}&productId=${product_id}&ruleId=${rule_id}`
    )
  } else {
    return await axiosInstance.get(
      `${
        API_END_POINT.CORE
      }v1/eligibility_configuration/${rule_name?.toLowerCase()}?programId=${program_id}&ruleId=${rule_id}`
    )
  }
}

export const updateCorrespondingRules = async (
  payload: IUpdateRulePayloadType
) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}v1/eligibility_configuration`,
    payload
  )
}

export const fetchEntityCategory = async (payload: IEntityCategoryPayload) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/category`,
    payload
  )
}

export const fetchEntityState = async (payload: IEntityCategoryPayload) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/state`,
    payload
  )
}
